module.exports = __webpack_public_path__ + "static/media/bio.1dafeba0.JPG";